import { withStyle } from 'styletron-react';
import { BorderedContainer } from '../../../components/BorderedContainer';

export const NavigationContainer = withStyle(BorderedContainer, {
  margin: '40px 0',
  padding: '20px 10px 10px',
});
